export function openChineseActivityPage() {
  open(import.meta.env.VITE_WEBSITE + "/promotion/year-end.html");
}

export function openChineseSpecialOffersPage() {
  open(import.meta.env.VITE_WEBSITE + "/promotion/exclusive-offer.html");
}

export function openLowPaymentOffersPage() {
  open(import.meta.env.VITE_WEBSITE + "/promotion/india-plan.html");
}


export function openPKLowPaymentOffersPage() {
  open(import.meta.env.VITE_WEBSITE + "/promotion/pakistan-plan.html");
}
export function openNGLowPaymentOffersPage() {
  open(import.meta.env.VITE_WEBSITE + "/promotion/nigeria-plan.html");
}